<!-- don't render the header on this page -->
<div class="switch-user">
  <div class="content">
    <div class="switch-user-header">
      <img src="/assets/images/logo.png" class="switch-logo" alt="logo" />
      <div class="title-wrapper">
        <h1 class="title s-30">Switch to other account</h1>
        <p class="text s-16">Get insights from another account</p>
      </div>
    </div>
    <div class="table-wrapper">
      <nz-table
        [nzData]="organizations"
        [nzScroll]="{ x: '700px', y: 'calc(100vh - 482px)' }"
        [nzShowPagination]="false"
        [nzLoading]="loader">
        <thead>
          <tr>
            <th nzWidth="250px">{{ listOfColumn[0].title }}</th>
            <th nzWidth="200px" nzAlign="center">
              {{ listOfColumn[1].title }}
            </th>
            <th nzWidth="120px" nzAlign="center">
              {{ listOfColumn[2].title }}
            </th>
            <th nzWidth="150px" nzAlign="center">
              {{ listOfColumn[3].title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of organizations">
            <td nzAlign="center">
              <div class="contact-wrapper">
                <!-- <img
                  src="/assets/images/avatar.png"
                  alt="user avatar"
                  class="person-img" /> -->
                <div class="details">
                  <!-- <h5 class="title s-12">Olivia Rhye</h5> -->
                  <span class="text s-12 email">{{
                    data?.organizationName
                  }}</span>
                </div>
              </div>
            </td>
            <td nzAlign="center">
              {{
                !!data?.lastLogin
                  ? (data.lastLogin ?? null | userDate: 'MM/dd/yyyy hh:mm a')
                  : '-'
              }}
            </td>
            <td nzAlign="center">
              <div
                class="status"
                [class.active]="data?.subscriptionStatus === 'Active'"
                [class.pending]="data?.subscriptionStatus === 'Expired'"
                [class.inactive]="data?.subscriptionStatus === 'Inactive'">
                <span>{{ data?.subscriptionStatus }}</span>
              </div>
              <!-- <div class="status pending">
                <span>Pending</span>
              </div> -->
            </td>
            <td nzAlign="center">
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  type="button"
                  *ngIf="orgData?.organizationId !== data.id"
                  nzType="default"
                  (click)="switch(data.id)">
                  Select
                </button>

                <!-- &&
                    data.subscriptionStatus === 'Active' -->

                <button
                  *ngIf="!!orgData && orgData?.organizationId === data.id"
                  nz-button
                  type="button"
                  nzType="text"
                  class="primary-text-btn">
                  Selected
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
